var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.76153 10.3953H9.83282H10.0923H15.1635C15.59 10.3953 15.9251 10.0791 15.9251 9.69767C15.9251 9.31628 15.5798 9 15.1635 9H10.0923H9.83282H4.76153C4.34523 9 4 9.31628 4 9.69767C4 10.0791 4.34523 10.3953 4.76153 10.3953Z",
    fill: "#2B4D65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.76153 6.39535H9.83282H10.0923H15.1635C15.59 6.39535 15.9251 6.07907 15.9251 5.69767C15.9251 5.31628 15.5798 5 15.1635 5H10.0923H9.83282H4.76153C4.34523 5 4 5.31628 4 5.69767C4 6.07907 4.34523 6.39535 4.76153 6.39535Z",
    fill: "#2B4D65"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.76153 14.2977H9.83282H10.0923H15.1635C15.59 14.2977 15.9251 13.9814 15.9251 13.6C15.9251 13.2186 15.5798 12.9023 15.1635 12.9023H10.0923H9.83282H4.76153C4.34523 12.9023 4 13.2186 4 13.6C4 13.9814 4.34523 14.2977 4.76153 14.2977Z",
    fill: "#2B4D65"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7907 20H7.2093C2.15814 20 0 17.8419 0 12.7907V7.2093C0 2.15814 2.15814 0 7.2093 0H12.7907C17.8419 0 20 2.15814 20 7.2093V12.7907C20 17.8419 17.8419 20 12.7907 20ZM7.2093 1.39535C2.92093 1.39535 1.39535 2.92093 1.39535 7.2093V12.7907C1.39535 17.0791 2.92093 18.6047 7.2093 18.6047H12.7907C17.0791 18.6047 18.6047 17.0791 18.6047 12.7907V7.2093C18.6047 2.92093 17.0791 1.39535 12.7907 1.39535H7.2093Z",
    fill: "#2B4D65"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/details.6085d48cc58464b94103b31b8c73526d.svg";
export { ForwardRef as ReactComponent };